'use strict';

import '../vendor/ly_components/index.js';
import Factory from './environments/base/factory.js';

const env = Factory.create(name);
env.init()
